

export function combineClassNames(...arr: string[]): string {
    return arr.filter(s => s && s.length).join(" ");
}



// WEBPACK FOOTER //
// ./Client/Utils/ReactUtils.ts